import { withInstall } from '@ll-plus/utils'

import InlineStepper from './src/inline-stepper.vue'

export const LlInlineStepper = withInstall(InlineStepper)
export default LlInlineStepper
export * from './src/inline-stepper'

declare module 'vue' {
  export interface GlobalComponents {
    LlInlineStepper: typeof InlineStepper
  }
}
